module.exports = __webpack_public_path__ + "images/163_4096.jpg";